export default [
	'Flex',
	'Warehouse',
];